/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnfilteredTagUpdate
 */
export interface UnfilteredTagUpdate {
    /**
     * 
     * @type {Array<number>}
     * @memberof UnfilteredTagUpdate
     */
    roots: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof UnfilteredTagUpdate
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UnfilteredTagUpdate
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnfilteredTagUpdate
     */
    color?: string;
}

export function UnfilteredTagUpdateFromJSON(json: any): UnfilteredTagUpdate {
    return UnfilteredTagUpdateFromJSONTyped(json, false);
}

export function UnfilteredTagUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnfilteredTagUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roots': json['roots'],
        'name': json['name'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'color': !exists(json, 'color') ? undefined : json['color'],
    };
}

export function UnfilteredTagUpdateToJSON(value?: UnfilteredTagUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roots': value.roots,
        'name': value.name,
        'shared': value.shared,
        'color': value.color,
    };
}


